/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Combo_Invalid_QuantityInputs */

const vi_error_combo_invalid_quantity = /** @type {(inputs: Error_Combo_Invalid_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng mỗi thành phần phải lớn hơn 0.`)
};

/**

* @param {Error_Combo_Invalid_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_combo_invalid_quantity = /** @type {((inputs?: Error_Combo_Invalid_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Combo_Invalid_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_combo_invalid_quantity(inputs)
});